import { api } from "../lib";
import { INTERNAL_RENDER_ROUTES } from "../lib/internalRenderAuth";

export interface InternalRenderImage {
  id: string;
  caption?: string;
  magnification?: string;
  displayOrder: number;
  mimeType?: string;
}

export interface InternalRenderFile {
  id: string;
  name: string;
  mimeType: string;
  label?: string;
}

export interface InternalRenderAttachments {
  images: InternalRenderImage[];
  files: InternalRenderFile[];
}

type ResolvedAttachmentUrl = { url: string };

export const internalRenderService = {
  getAttachments: (): Promise<InternalRenderAttachments> =>
    api.get<InternalRenderAttachments>(INTERNAL_RENDER_ROUTES.attachments),

  getSelectedImageUrl: (assetId: string): Promise<ResolvedAttachmentUrl> =>
    api.post<ResolvedAttachmentUrl>(INTERNAL_RENDER_ROUTES.selectedImageUrl, {
      assetId,
    }),

  getSelectedFileUrl: (assetId: string): Promise<ResolvedAttachmentUrl> =>
    api.post<ResolvedAttachmentUrl>(INTERNAL_RENDER_ROUTES.selectedFileUrl, {
      assetId,
    }),
};
